import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import {
  BreadcrumbsDataService,
  Crumb,
} from '../../../research/services/breadcrumbs.service'
import { SearchStateService } from '../../../research/services/search-state.service'
import {
  CyborgRouterSearchLink,
  SearchUrlService,
} from '../../../research/services/search-url.service'

@Component({
  standalone: false,
  selector: 'cyborg-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
  private bread = inject(BreadcrumbsDataService)
  searchStateService = inject(SearchStateService)
  private searchUrlService = inject(SearchUrlService)

  public sub: Crumb
  public subSub: Crumb
  public searchLink: Observable<CyborgRouterSearchLink>

  public ngOnInit(): void {
    this.searchLink = this.searchStateService.state.pipe(
      map((state) => this.searchUrlService.stateToRouterLink(state)),
    )

    this.bread.subCrumb.subscribe((sub) => {
      this.sub = sub
    })

    this.bread.subSubCrumb.subscribe((sub) => {
      this.subSub = sub
    })
  }

  public clearAllFilters(): void {
    this.searchStateService.reset()
  }
}
